module.exports = __webpack_public_path__ + "img/logo-circle.2111524d.svg";